import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

function ListUsersB2b() {
  const [users, setUsers] = useState([]);
  const history = useHistory();

  useEffect(() => {
    axios
      .get('/api/b2b/all')
      .then((res) => setUsers(res.data))
      .catch((err) => console.error(err));
  }, []);

  const fmtDate = (d) => (d ? new Date(d).toLocaleString('fr-FR') : '—');
  const fmtPay = (m) => (m === 'account' ? 'En compte' : 'CB');

  return (
    <div className="mt-4">
      {users.length === 0 ? (
        <p>Aucun utilisateur trouvé.</p>
      ) : (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Entreprise</th>
              <th>Email</th>
              <th>SIRET</th>
              <th>Téléphone</th>
              <th>Adresse</th>
              <th>Mode paiement</th>
              <th>Remise (%)</th>
              <th>PGI Code</th>
              <th>Statut</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr key={u._id}>
                <td>{u.companyName}</td>
                <td>
                  {u.email && u.email.length > 20 ? u.email.substring(0, 25) + '...' : u.email}
                </td>
                <td>{u.siret}</td>
                <td>{u.phone}</td>
                <td>
                  {u.adresse ||
                    `${u.address?.street || ''}, ${u.address?.postalCode || ''} ${
                      u.address?.city || ''
                    }`}
                </td>
                <td>{fmtPay(u.paymentMode)}</td>
                <td>{u.discount ?? 0}</td>

                <td>
                  {u.pgiAgencyCode ? (
                    <span className="badge bg-info" style={{ color: '#fff' }}>
                      {u.pgiAgencyCode}
                    </span>
                  ) : (
                    <span className="text-muted">—</span>
                  )}
                </td>

                <td>
                  <span
                    className={`badge ${
                      u.status === 'valid'
                        ? 'bg-success'
                        : u.status === 'disable'
                        ? 'bg-secondary'
                        : 'bg-warning'
                    }`}
                    style={{ color: '#fff' }}
                  >
                    {u.status}
                  </span>
                </td>

                <td>
                  <button
                    className="btn btn-outline-primary"
                    style={{ padding: '3px 10px', fontSize: 12 }}
                    onClick={() => history.push(`/b2b/admin/users/${u._id}`)}
                  >
                    Gérer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ListUsersB2b;
